import { render, staticRenderFns } from "./cascader-dw.vue?vue&type=template&id=085f2b5c&"
import script from "./cascader-dw.vue?vue&type=script&lang=js&"
export * from "./cascader-dw.vue?vue&type=script&lang=js&"
import style0 from "./cascader-dw.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports